import CartItemStyles from "./cart-item.module.css"
import { CartItem as CartItemType } from "../../sdk/types"
import { Image } from "../universal/image"
import React from "react"
import classNames from "classnames"

type CartItemProps = {
    item: CartItemType
}

const CartItem = ({ item }: CartItemProps) => {
    const image = item.product.marketing.images.find(i => i.type === "main")
    return (
        <li className={classNames(CartItemStyles.block, { [CartItemStyles.error]: item.error })}>
            <div className={CartItemStyles.image}>
                {image && (
                    <Image
                        url="assets"
                        path={image.href.replace(process.env.IMG_CDN_URL_ASSETS, "")}
                        srcSet={[{ w: 60, default: true }, { w: 120 }]}
                        sizes="60px"
                        alt=""
                    />
                )}
            </div>
            <div className={CartItemStyles.item}>
                <p>{item.product.name.long}</p>
                <span>{item.quantity}x</span>
            </div>
        </li>
    )
}

export default CartItem
